import { useEffect } from 'react';

interface PageMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  schemaJson?: object;
}

export default function PageMeta({
  title,
  description,
  keywords,
  canonicalUrl = 'https://bluenav.cn',
  ogType = 'website',
  schemaJson,
}: PageMetaProps) {
  const fullTitle = `${title} | 蓝色小导航`;

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);

    const existingCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (existingCanonical) {
      existingCanonical.href = canonicalUrl;
    }

    let schemaEl = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement | null;
    if (schemaJson) {
      if (!schemaEl) {
        schemaEl = document.createElement('script');
        schemaEl.type = 'application/ld+json';
        document.head.appendChild(schemaEl);
      }
      schemaEl.textContent = JSON.stringify(schemaJson);
    } else if (schemaEl) {
      schemaEl.remove();
    }

    return () => {
      if (schemaEl && schemaJson) {
        // keep schema on unmount, let next page override
      }
    };
  }, [fullTitle, description, keywords, canonicalUrl, ogType, schemaJson]);

  return null;
}